import { render } from "./LogoImageBackground.vue?vue&type=template&id=ac108ee6&ts=true"
import script from "./LogoImageBackground.vue?vue&type=script&lang=ts"
export * from "./LogoImageBackground.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__